import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_REPORTS_ROUTE } from "../../../../../constants/routes"
import { PosTransactionsTable, ProductionOrderTypeFilter } from "./components/PosTransactionsTable"

export function Takeaway() {
    return (
        <>
            <LocalizedStrict id="production-takeaway-page-header" attrs={{ title: true }}>
                <PageHeader page={Page.PRODUCTION_TAKE_AWAY} title="Takeaway">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_REPORTS_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>

                        <LocalizedStrict id="merchant-production">
                            <Breadcrumb>Production</Breadcrumb>
                        </LocalizedStrict>

                        <LocalizedStrict id="production-takeaway-breadcrumb">
                            <Breadcrumb>Takeaway</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <PosTransactionsTable isTakeaway defaultOrderType={ProductionOrderTypeFilter.TAKEAWAY} />
        </>
    )
}

